import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { IRootState } from '../../../../../redux/reducers-types';
import {
    setHighlightIndexAction,
    setSelectedIssueAction,
    setSelectedParagraphAction,
    updateIssueAction,
} from '../../../../Contract/Contract-actions';
import { HighlightIndexType } from '../../../../Contract/Contract-types';
import { IContractParagraph } from '../../../../Paragraph/Paragraph-types';
import { IPropertySuggestion } from './ParagraphSuggestion/ParagraphSuggestion-types';

import ParagraphSuggestions from './ParagraphSuggestions';
import {
    resetSuggestionsAction,
    setSuggestionsAction,
    setSuggestionsInitialLoadCompletedAction,
    setSuggestionsLoadingAction,
} from './ParagraphSuggestions-actions';
import {
    IParagraphSuggestionsDispatchProps,
    IParagraphSuggestionsStateProps,
} from './ParagraphSuggestions-types';
import { ContractIssue } from '@thought-river/negotiations-common';
import { setBannerSettingsAction } from '../../../../HeatmapPane/HeatmapPane-actions';

function mapStateToProps(state: IRootState): IParagraphSuggestionsStateProps {
    return {
        count: state.paragraphSuggestions.count,
        featureToggles: state.featureToggles.toggles,
        highlightedParagraphs: state.contract.highlightedParagraphs,
        issue: state.contract.selectedIssue,
        initialLoadCompleted: state.paragraphSuggestions.initialLoadCompleted,
        loading: state.paragraphSuggestions.loading,
        nextPageNumber: state.paragraphSuggestions.nextPageNumber,
        paragraphs: state.contract.paragraphs,
        suggestions: state.paragraphSuggestions.suggestions,
        streamCode: state.contract.contract?.streamCode,
    };
}

function mapDispatchToProps(
    dispatch: Dispatch<AnyAction>
): IParagraphSuggestionsDispatchProps {
    return {
        resetSuggestions: () => dispatch(resetSuggestionsAction()),
        setSuggestionsInitialLoadCompleted: (loaded: boolean) =>
            dispatch(setSuggestionsInitialLoadCompletedAction(loaded)),
        setSuggestionsLoading: (loading: boolean) =>
            dispatch(setSuggestionsLoadingAction(loading)),
        setSuggestions: (
            suggestions: IPropertySuggestion[],
            count?: number,
            pageNumber?: number
        ) => dispatch(setSuggestionsAction(suggestions, count, pageNumber)),
        setHighlightIndex: (index: number, highlightType: HighlightIndexType) =>
            dispatch(setHighlightIndexAction(index, highlightType)),
        setSelectedIssue: (selectedIssue: ContractIssue) =>
            dispatch(setSelectedIssueAction(selectedIssue)),
        setSelectedParagraph: (paragraph: IContractParagraph) =>
            dispatch(setSelectedParagraphAction(paragraph)),
        updateIssue: (issue: ContractIssue) =>
            dispatch(updateIssueAction(issue)),
        setBannerSettings: (...args) =>
            dispatch(setBannerSettingsAction(...args)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ParagraphSuggestions);
